import devices from 'devextreme/core/devices';
import dxPopup, {Properties} from 'devextreme/ui/popup';
import {ConteudoTab} from './ConteudoTab';
import {converteVhParaPx} from "../telas/jornada/Utils";
import dxScrollView from "devextreme/ui/scroll_view";

/**
 * Propriedades do popup padrão
 * @interface PropriedadesPopup
 * @property {boolean} [desabilitarBotaoConfirmar] - Indica se o botão que chama a função getPopupConfirmacao deve ser exibido
 * @property {boolean} [desabilitarBotaoCancelar] - Indica se o botão que chama a função getPopupCancelamento deve ser exibido
 * @property {string} [textoBotaoConfirmar="OK"] - Texto do botão de confirmação, aplicável quando o botão é exibido
 * @property {string} [textoBotaoCancelar="Cancelar"] - Texto do botão de cancelar, aplicável quando o botão é exibido
 * @property {(null|boolean)} [fecharAoConfirmar] - Indica se o popup deve ser fechado ao clicar no botão de confirmação
 * @property {boolean} [fullScreen] - Indica se o popup deve ser exibido em fullscreen, falso nos casos de dispositívos desktop
 * @property {[{}]} [customButtons] - Lista de botões adicionais do popup
 * @property {dxButtonOptions} [propsBotaoConfirmar] - Propriedades adicionais para o botão de confirmar
 */


export class PopUpPadrao extends ConteudoTab {
    /**
     * @param {(Properties, PropriedadesPopup)} propriedades
     * @param {string} nomeClasse
     * @param {string} tituloPopup
     */
    constructor(propriedades, nomeClasse, tituloPopup, renderOnly = false) {
        super(nomeClasse);

        const customButtons = propriedades?.customButtons ?? []

        /**
         * @type {Properties}
         */
        const props = {
            title: tituloPopup,
            toolbarItems: [
                propriedades.desabilitarBotaoConfirmar ? {} :
                    {
                        toolbar: 'bottom',
                        widget: "dxButton",
                        location: "after",
                        options: {
                            text: propriedades.textoBotaoConfirmar ? propriedades.textoBotaoConfirmar : "OK",
                            onClick: async (e) => {
                                try {
                                    const promise = this.getPopupConfirmacao(e)
                                    if (promise.hasOwnProperty('always'))
                                        promise.always((_) => this.botaoConfirmar.option("disabled", false))
                                    if (promise.hasOwnProperty('finally'))
                                        promise.finally((_) => this.botaoConfirmar.option("disabled", false))

                                    await promise
                                        .then(_ => {
                                            if (propriedades.fecharAoConfirmar === false) return

                                            this.popupInstance.dispose()
                                            this.popup.remove()
                                        })
                                        .catch(reason => {
                                            throw reason
                                        })
                                } catch (error) {
                                    console.error(error);
                                    this.botaoConfirmar.option("disabled", false)
                                }
                            },
                            onInitialized: (e) => this.botaoConfirmar = e.component,
                            // Confirmar em destaque no padrão do Design System.
                            // Antes de propsBotaoConfirmar de propósito: a tela
                            // que precisar de outro acabamento ainda o sobrepõe.
                            ...(propriedades.designSystem
                                ? {elementAttr: {class: 'botao-salvar-ds'}}
                                : {}),
                            ...propriedades.propsBotaoConfirmar
                        }
                    },
                propriedades.desabilitarBotaoCancelar ? {} :
                    {
                        toolbar: 'bottom',
                        widget: "dxButton",
                        location: "after",
                        options: {
                            text: propriedades.textoBotaoCancelar ? propriedades.textoBotaoCancelar : "Cancelar",
                            onClick: (e) => {
                                this.getPopupCancelamento(e);
                                this.popupInstance.dispose()
                                this.popup.remove();
                            }
                        }
                    },
                ...customButtons
            ],
            ...propriedades
        };

        props.onShown = (e) => {
            this.onShown(e);
        };

        props.onHiding = (e) => {
            this.onHiding(e)
        };

        props.contentTemplate = (e) => {
            const renderScrollView = _ => {
                const content = $(".scroll-group")

                if (content.length === 0) return

                new dxScrollView(content, {
                    showScrollbar: "always",
                })
            }

            const doRender = this.getContentTemplate();

            if (!(doRender instanceof Promise)) {
                doRender.appendTo(e);
                renderScrollView()
                return
            }

            doRender.then(result => {
                result.appendTo(e);
                renderScrollView()
            });
        };

        props.onHidden = (e) => {
            this.onHidden(e)
            this.popup.remove();
        };

        const defaultView = devices.current();

        props.showCloseButton = true;
        props.fullScreen = propriedades.fullScreen ?? (defaultView.deviceType !== "desktop");

        this.popup = $("<div />");

        /*
         * Adesão ao Design System (JOR4-7575). Chega por `designSystem` nas
         * propriedades — a tela migrada liga, ou o GridPadrao repassa para os
         * popups que ele abre (edição, visões, formulário personalizado).
         *
         * Só a classe entra aqui: o cabeçalho na cor da marca, o raio de 16px, o
         * rodapé e o acabamento dos botões são desenhados por `.popup-ds` em
         * css/jornada.css, que também alcança o `.dx-popup-title` e o
         * `.dx-popup-bottom` deste dxPopup.
         */
        const classesDoWrapper = [
            propriedades.wrapperAttr?.class,
            propriedades.designSystem ? 'popup-ds' : null,
        ].filter(Boolean);

        // A flag não é opção do dxPopup: sai antes de o widget ser criado.
        delete props.designSystem;

        const popupInstance = new dxPopup(this.popup, {
            ...props,
            wrapperAttr: {
                ...(renderOnly ? { data: "hidden-content" } : {}),
                ...(propriedades.wrapperAttr ?? {}),
                ...(classesDoWrapper.length
                    ? {class: classesDoWrapper.join(' ')}
                    : {}),
            },
        });

        this.setDxPopUp(popupInstance);
    }

    /**
     * @return {jQuery | HTMLElement | JQuery<HTMLElement>}
     */
    getContentTemplate() {
        alert('Falta sobrescrever o método getContentTemplate() ');
    }

    getPopupCancelamento() {

    }

    onShown(e) {

    }

    /**
     * @return {Promise, Deferred}
     */
    getPopupConfirmacao(e) {
        alert('Falta sobrescrever o método getPopupConfirmacao()');
    }

    /**
     * @returns {jQuery|HTMLElement|JQuery<HTMLElement>}
     */
    getRender() {
        return this.popup;
    }

    /**
     * @returns {dxPopup}
     */
    getDxPopUp() {
        return this.popupInstance;
    }

    /**
     * @param {dxPopup} popupInstance
     */
    setDxPopUp(popupInstance) {
        this.popupInstance = popupInstance;
    }

    /**
     * @return {number}
     */
    getLarguraConteudoPopUp() {
        const larguraPopUp = this.getDxPopUp().option("width");
        return (larguraPopUp - 25);
    }

    /**
     * @return {number}
     */
    getAlturaConteudoPopUp() {
        const alturaPopUp = this.getDxPopUp().option("height");
        const descontoDeAltura = 90

        if (typeof alturaPopUp === "function") {
            return (converteVhParaPx(alturaPopUp()) - descontoDeAltura);
        }
        return (converteVhParaPx(alturaPopUp) - descontoDeAltura);
    }

    closePopup() {
        return this.getDxPopUp().dispose();
    }

    onHiding(e) {
        return e
    }

    onHidden(e) {
        return e
    }
}
